import SweetAlertContainer from "../../components/bonusUi/sweetAlert";

const SweetAlert = () => {
  return <SweetAlertContainer />;
};

export default SweetAlert;
